$(window).load(function() {
    $('.bxslider').bxSlider({
        responsive: true,
        startSlide: 0
    });
});

$(document).ready(function() {
    $('.product-right').stick_in_parent();

    $('.currency-selector-list').on('click', '.init', function(e) {
        e.stopPropagation();
        $(this).closest('ul').children('li:not(.init)').toggle();
        $('.currency-selector-chevron').toggleClass('unselected');
        $('.currency-selector-chevron').toggleClass('selected');
    });

    var allOptions = $('.currency-selector-list').children('li:not(.init)');
    $('.currency-selector-list').on('click', 'li:not(.init)', function() {
        $('.currency-selector-list').children('.init').html($(this).html());
        allOptions.toggle();
        $('.doubly-nice-select li[data-value="' + $(this).html() + '"]').trigger('click');
    });
    $(window).click(function() {
        allOptions.hide();
        $('.currency-selector-chevron').removeClass('selected');
        $('.currency-selector-chevron').addClass('unselected');
    });
    // We need to set the initial state based on the current currency.
    function waitForElement(){
        if(typeof initBestCurrencyConverter !== 'undefined' && typeof DoublyGlobalCurrency !== 'undefined') {
            $('.currency-selector-list li.init').html(DoublyGlobalCurrency.currentCurrency);
            $('.currency-selector-list').removeClass('visually-hidden');
        }
        else{
            setTimeout(waitForElement, 250);
        }
    }
    waitForElement();

    /* Cart integration start */
    function updateMiniCart(cart) {
        if (cart.item_count == 0) {
            $('#TrystCartCount').html('');
            $('#TrystCartPcs').addClass('visually-hidden');
        } else {
            var price = theme.Currency.formatMoney(cart.total_price, '{{amount_no_decimals}}');
            price = price.replace('.00', '');
            //price = price.replace('$', '');
            price = price.replace(',', ' ');
            $('#TrystCartCount').html(cart.item_count);
            $('#TrystCartPrice').html('<span class="money">' + price + '</span>');
        }
    }
    $('body').on('submit', '.shopping-cart-wrapper form', function() {
        if (!$('#terms').is(":checked")) {
            alert('You need to agree to our terms & conditions.');
            return false;
        }
    });
    var cartPopup = $('.cart-popup')
    $("#cart-logo a[href='/cart']").click(function() {
       $.get({
           url: '/cart',
           success: function(data) {
               var template = $(data).find('#shopify-section-cart-template').html();
               $('body').addClass('body--overflow');
               cartPopup.html(template).removeClass('cart--hidden');
           }
       });
       return false;
    });
    $('body').on('click', '.clear-cart-item', function() {
        var id = $(this).parents('.cart-product').data('id');
        $.post({
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: 0,
                id: id
            },
            success: function(data) {
                $.get({
                    url: '/cart',
                    success: function(data) {
                        var template = $(data).find('#shopify-section-cart-template').html();
                        $('.cart-popup').html(template);
                        $.getJSON('/cart.js', updateMiniCart);
                    }
                });
            },
            error: function(error) {
                alert(error.responseJSON.description);
            }
        });
        return false;
    });
    $('body').on('click', '.add-cart-item', function() {
        var id = $(this).parents('.cart-product').data('id');
        var quantity = $(this).parents('.cart-product').data('quantity');
        $.post({
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: quantity + 1,
                id: id
            },
            success: function(data) {
                $.get({
                    url: '/cart',
                    success: function(data) {
                        var template = $(data).find('#shopify-section-cart-template').html();
                        $('.cart-popup').html(template);
                        $.getJSON('/cart.js', updateMiniCart);
                    }
                });
            },
            error: function(error) {
                alert(error.responseJSON.description);
            }
        });
        return false;
    });
    $('body').on('click', '.remove-cart-item', function() {
        var id = $(this).parents('.cart-product').data('id');
        var quantity = $(this).parents('.cart-product').data('quantity');
        $.post({
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: quantity - 1,
                id: id
            },
            success: function(data) {
                $.get({
                    url: '/cart',
                    success: function (data) {
                        var template = $(data).find('#shopify-section-cart-template').html();
                        $('.cart-popup').html(template);
                        $.getJSON('/cart.js', updateMiniCart);
                    }
                });
            },
            error: function(error) {
                alert(error.responseJSON.description);
            }
        });
        return false;
    });

    $(document).on ('click', '.close-cart-btn', function() {
        $('.cart-popup').addClass('cart--hidden');
        $('body').removeClass('body--overflow');
    });
    /* Cart integration end */

    /* Mailchimp start */
    function showNewsLetterPopup() {
        $('#mc_embed_signup').show();
        $('html, body').animate({
            scrollTop: 0
        }, 300, function(){

        });
    }
    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    if (!getCookie('mc_popup_closed')) {
        showNewsLetterPopup();
    }

    $(document).on('click', 'a', function(el) {
        if($(this).data('trigger') == 'newsletter') {
            showNewsLetterPopup();
        }
    });
    $('#mc_embed_close').click(function() {
        $('#mc_embed_signup').hide();
        setCookie('mc_popup_closed', 1);
    });
    /* Mailchimp end */

    if ($('body').hasClass('template-index')) {
        $('.tryst-site-header').css('height', '100vh');
    } else {
        $('.tryst-site-header').css('height', 'auto');
    }

    var topLogo = $('.top-logo');
    var siteLogo = $('.header-logo');



        if (!sessionStorage.getItem('HasVisitedFirst')) {
            topLogo.delay(4000).fadeIn();
            siteLogo.delay(4000).fadeOut();
            sessionStorage.setItem('HasVisitedFirst',true);
        } else {
            topLogo.show();
            siteLogo.hide();
        }



    // Move size selection and add to cart on top of description on small screens
    function productOrder() {
        if ($(window).width() < 400) {
            $('.add-item').insertBefore('.product-single__description');
        }else if($(window).width() > 400) {
            $('.add-item').insertAfter('.product-single__description');
        }
    }
    productOrder();
    $(window).bind('resize',function(){
        productOrder();
    });

    $('.product-form__cart-submit').click(function() {
        if (!$("input[name='id']:checked").val()) {
            $(this).prop('disabled', true);
            $('.no-size-selected').addClass('no-size-selected--visible');
        }
    });

    $('input[name="id"]').change(function() {
        $('.product-form__cart-submit').prop('disabled', false);
        $('.no-size-selected').removeClass('no-size-selected--visible');
    });
});
